import { DismantlingBayType } from "../models/DismantlingBay";
import { ProductionDashboardView } from "../models/ProductionDashboard";

/**
 * The Line/Bays toggle the Production Dashboard persists. Shared because anything that wants to
 * show the same figures as that dashboard has to ask the overview endpoint for the same bay type —
 * the payload only ever contains bays of one type, so a mismatch here silently counts nothing.
 */
export const PRODUCTION_VIEW_STORAGE_KEY = "productionDashboard.view";

export function readStoredProductionView(): ProductionDashboardView {
  if (typeof window === "undefined") return "Line";
  const value = window.localStorage.getItem(PRODUCTION_VIEW_STORAGE_KEY);
  return value === "Bays" ? "Bays" : "Line";
}

export function bayTypeForProductionView(view: ProductionDashboardView): DismantlingBayType {
  return view === "Line" ? DismantlingBayType.ProductionLine : DismantlingBayType.Bay;
}
